import { Tooltip } from 'antd';

import Icon from '@ant-design/icons';
import UserAction from '../../common/components/UserAction';
import LinkWithTargetBlank from '../../common/components/LinkWithTargetBlank';
import EventTracker from '../../common/components/EventTracker';
import blueskyLogo from '../../common/assets/bluesky.svg?react';

const AuthorBlueskyAction = ({ bluesky }: { bluesky: string }) => {
  const href = `//bsky.app/profile/${bluesky}`;
  return (
    <UserAction>
      <EventTracker
        eventCategory="Author detail"
        eventAction="Link"
        eventId="Bluesky"
      >
        <LinkWithTargetBlank href={href}>
          <Tooltip title="Bluesky">
            <Icon component={blueskyLogo} />
          </Tooltip>
        </LinkWithTargetBlank>
      </EventTracker>
    </UserAction>
  );
};

export default AuthorBlueskyAction;
